import type { SettingsConfig } from '@ardoq/view-settings';
import { ViewIds } from '@ardoq/api-types';
import type { I18nLocale } from '@ardoq/i18n';
import { referenceLinesDropdown } from 'tabview/assistantShared/referenceLines';
import type { AssistantBlocksDisplaySettings } from './viewModel$';

type GetViewModifiersArgs = {
  viewSettings: AssistantBlocksDisplaySettings;
  i18nLocale: I18nLocale;
};

export const getAssistantBlocksViewModifiers = ({
  viewSettings,
  i18nLocale,
}: GetViewModifiersArgs): SettingsConfig[] => [
  referenceLinesDropdown(ViewIds.ASSISTANT_BLOCKS, viewSettings, i18nLocale),
];
